import React, { Component, PropTypes } from 'react';
import {reduxForm} from "redux-form";
import {GetInterfaceLang, GetOneLanguage, GetOneLearningLanguage, saveWord, getDetailWord, saveWordEdit} from '../../actions/index';
import {Link} from 'react-router';

class AddWord  extends Component {
    static contextTypes = {
        router: PropTypes.object
    };
    constructor(props){
        super(props);
        this.state={
            word: ''
        }
        this.renderTranslate = this.renderTranslate.bind(this);
        this.onChange = this.onChange.bind(this);
        this._logStateRaw = this._logStateRaw.bind(this);
        this.SubmitForm = this.SubmitForm.bind(this);
        this.changeInput = this.changeInput.bind(this);
        this.translation = this.translation.bind(this);
    }
    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        this.props.GetInterfaceLang(token);
        this.props.GetOneLearningLanguage(this.props.params.id, token);
        if(this.props.params.id_word){
            this.props.getDetailWord(this.props.params.id_word, token, this.props.params.id);
        }
    }
    componentDidMount(){
        $('#word').keypress(function () {
            $(this).parent().removeClass('has-error')
        });
    }
    componentWillUnmount(){
        this.props.lang.words_detail = {}
        this.props.lang.error_word = {}
    }
    edit(e){
        let block = $(e.target).data('id')
        $('#'+block+' .idetBlock').summernote({
            lang: "ru-RU",
            height: 150,
            dialogsInBody: true,
            toolbar: [
                ["font", ["bold", "underline", "clear"]],
                ['fontsize', ['fontsize']],
                ['color', ['color']],
                ["para", ["ul", "ol", "paragraph"]],
                ["table", ["table"]],
                ["insert", ["link", "picture", "video"]],
                ["view", ["fullscreen", "codeview"]]
            ]
        });
        $('#'+block+' .btn-primary').show();
    };
    save(e){
        let block = $(e.target).data('id')
        let makrup = $('#'+block+' .idetBlock').summernote('code');
        $('#'+block+' .idetBlock').summernote('destroy');
        $('#'+block+' .btn-primary').hide();
        $('#'+block+' .idetBlock').closest('.addWordBlock').removeClass('has-error');
    };
    SubmitForm(){
        let token = localStorage.getItem('id_token_admin');
        // if(this.props.params.id_word){
        //     if($('#word').val() != ''){
        //
        //     }else{
        //         $('#word').parent().addClass('has-error')
        //     }
        // }else{
        if($('#word').val() != ''){
            let block = $('.addWordBlock');
            let arr = [];
            for(let i=0; i<block.length; i++){
                let oneBlock = block[i];
                if($(oneBlock).find('.idetBlock').html() != '' && $(oneBlock).find('.idetBlock').html() != '<p><br></p>'){
                    let obj={
                        word_translations: $(oneBlock).find('.idetBlock').html(),
                        blang: parseInt($(oneBlock).attr('id'))
                        // vocabulary_word: parseInt(this.props.params.id_word) || ' '
                    }
                    arr.push(obj)
                }else{
                    $(oneBlock).find('.idetBlock').closest('.addWordBlock').addClass('has-error');
                }
            }
            let data= {
                word: $('#word').val(),
                flang: parseInt(this.props.params.id),
                translations: arr
            };
            if($('.addWordForm').find('.has-error').length > 0){
                return false;
            }else{
                if(this.props.params.id_word){
                    this.props.saveWordEdit(token, data, this.props.params.id_word).then((response)=>{
                        if(response.payload.status == 200){
                            this.context.router.push('/language/learning/edit/'+this.props.params.id+'/vocabulary/');
                        }
                    });
                }else{
                    this.props.saveWord(token, data).then((response)=>{
                        if(response.payload.status == 201){
                            this.context.router.push('/language/learning/edit/'+this.props.params.id+'/vocabulary/');
                        }
                    });
                }
            }

        }else{
            $('#word').parent().addClass('has-error')
        }
        // }
    }
    changeInput(e){
        this.setState({
            word: e.target.value
        })
        this.props.fields[e.target.name].onChange(e.target.value);
    }
    _logStateRaw() {
        let editorState = this.state.value.getEditorState();
        let contentState = editorState.getCurrentContent();
        let rawContentState = window.rawContentState = convertToRaw(contentState);
    }
    translation(id) {
        if(id && this.props.lang.words_detail.translations){
            setTimeout(()=>{
                return this.props.lang.words_detail.translations.map((item)=> {
                    if (item.blang == id) {
                        $('#' + id + ' .idetBlock').text('');
                        $('#' + id + ' .idetBlock').append(item.word_translations)
                        // return item.word_translations
                    }
                });
            }, 500)
        }else{
            return  ''
        }
    }
    renderTranslate(){
        let elem = this.props.lang.interface_lang.results;

        return elem.map((item)=>{
            if(item.lang.id == this.props.lang.learning_lang_one.lang.id){
                return false
            }else{
                return(
                    <div className="row addWordBlock" id={item.id} key={item.lang.id}>
                        <div className="col-md-4">
                            <label>{item.lang.name}</label>
                        </div>
                        <div className="col-md-4" data-name={item.lang.name}>
                            {this.translation(item.id)}
                            <div className="idetBlock"></div>

                            <div className="blockBtn">
                                <button id="edit" data-id={item.id} className="btn btn-default" onClick={this.edit} type="button">Edit</button>
                                <button id="save" data-id={item.id} className="btn btn-primary" onClick={this.save} type="button">Save</button>
                            </div>
                        </div>
                    </div>
                )
            }
        })
    }
    onChange(e, content) {
        let nameBlock = $(e).parent().data('name');
        this.setState({
            [nameBlock]: content
        })
    }
    render() {
        const { fields: {word}} = this.props;
        return (
            <div className="dashboard-wrapper">
                <p className="dashboard-title">{this.props.params.id_word ? "Edit Word" : "Add Word"}</p>
                <p className="dashboard-text">{this.props.lang.learning_lang_one.lang ? this.props.lang.learning_lang_one.lang.name : "" }</p>
                <form className="addWordForm">
                    <div className="col-md-12">
                        <div className="white-block block-4-8 clearfix">
                            <div className='clearfix'>
                                <div className="col-md-4">
                                    <label htmlFor="word">Word in the foreign language</label>
                                </div>
                                <div className='col-md-4'>
                                    <input type="text"
                                           placeholder="Word"
                                           className="form-control"
                                           name="word"
                                           id="word"
                                           {...word}
                                           onChange={this.changeInput}
                                    />
                                </div>
                            </div>
                            <div className="clearfix blockTranslate">
                                <p className="title">Translate</p>
                                {this.props.lang.interface_lang.results ?
                                    <div className="col-md-12">
                                        {this.renderTranslate()}
                                    </div>
                                    : ""
                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="white-block clearfix">
                            <div className="col-md-12 text-center button-group">
                                {this.props.lang.error_word && this.props.lang.error_word.response ? <p className="errorForm"> {this.props.lang.error_word.response.data.non_field_errors[0]}</p> : ''}
                                <Link to={"/language/learning/edit/"+this.props.params.id+"/vocabulary/"} className="btn btn-default">Cancel</Link>
                                <button type="button" onClick={this.SubmitForm} className="btn btn-primary">Save</button>
                            </div>
                        </div>
                    </div>
                </form>
                <div className="clearfix"></div>
            </div>
        );
    }
}

function validate(values) {
    const errors = {};
    if(!values.word){
        errors.word = 'Enter a title'
    }
    return errors;
}

function  mapStateToProps(state) {
    return{
        lang: state.lang,
        initialValues: {
            word: state.lang.words_detail.word || ''
        }
    }
}
export default reduxForm({
    form: 'Add Word',
    fields: ['word'],
    validate
}, mapStateToProps, {GetInterfaceLang, GetOneLanguage, GetOneLearningLanguage, saveWord, getDetailWord, saveWordEdit})(AddWord);



// WEBPACK FOOTER //
// ./src/components/language/addWord.js